import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import Timer from "./components/Timer/index";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Timer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js